import { ActionType, createAction } from 'typesafe-actions'

export const UserActions = {
  setToken: createAction('USER/set-token')<{
    token: string
  }>(),
  logout: createAction('USER/logout')<{ isLoginAsMode?: boolean }>(),
  detectInvalidContract: createAction('USER/detect-invalid-contract')(),
  detectSessionTimeout: createAction('USER/detect-session-timeout')()
}

export type UserActions = ActionType<typeof UserActions>
